var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12"},[_c('edit-event-form',{key:_vm.$route.params.eventId,ref:"form",attrs:{"event-id":_vm.$route.params.eventId}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }